import styled from 'styled-components';
import ds, { media } from 'designsystem';

const BlogArticleBoldText = styled.span`
  font-weight: ${ds.get('type.fontWeight.regular')};
  font-family: ${ds.get('type.fontFamily.text')};
  font-size: ${ds.fs('blogArticleParagraph')};
  line-height: ${ds.get('type.lineHeight.base')};
  
  ${media.tablet`
    line-height: ${ds.get('type.lineHeight.l')};
  `}
`;

export default BlogArticleBoldText;



// WEBPACK FOOTER //
// ./src/elements/BlogArticleBoldText.js